import React,{useEffect, useState} from "react";
import { Link } from "react-router-dom";
import { CAMPAIGN_ALL_LINK, HOME_LINK, LOGIN_LINK, LOGOUT_LINK, RESET_PASSWORD_SLUG } from "../constants/constants";
import { isLoggedIn as hasSession } from "../helper";

const Header = () => {
    const [openMenu,setOpenMenu] = useState(false);
    const [sessionActive, setSessionActive] = useState(() => hasSession());
    const handleMobileMenu = () => {
        setOpenMenu(!openMenu);
    }
    useEffect(()=>{
        setSessionActive(hasSession());
    },[]);
    return(
        <div className="header-wrap">
            <div className="container">
                <header id="header">
                    <div className="top-logo">
                    {sessionActive ? <Link to={HOME_LINK}> <img src='/assets/images/logo-color-new.svg' alt="panacea logo" /></Link> : <img src='/assets/images/logo-color-new.svg' alt="panacea logo" />}
                    </div>
                    <div className="mobile-humburger">
                        <span className={openMenu ? 'line close-it' :'line'} onClick={ ()=>{handleMobileMenu()} }>Menu</span>
                    </div>
                    <nav className ={openMenu ? 'open-menu top-nav':'close-menu top-nav'}>
                        <ul>
                            {sessionActive && (
                            <>
                            <li>
                                <Link to="/">Home</Link>
                            </li>
                            <li>
                                <Link to={CAMPAIGN_ALL_LINK}>Campaigns</Link>
                            </li>
                            <li className="has-child">
                                <span className="no-link">Account</span>
                                <ul className="submenu">
                                    <li><Link to={`${RESET_PASSWORD_SLUG}${localStorage.getItem('token')}`}>Reset Password</Link></li>
                                    <li><Link to={LOGOUT_LINK}>Logout</Link></li>
                                </ul>
                            </li>
                            </>
                            )}
                            {!sessionActive && (
                            <li>
                                <Link to={LOGIN_LINK}>Login</Link>
                            </li>
                            )}
                        </ul>
                    </nav>
                </header>
            </div>
        </div>
    );
}

export default Header;